import { ClipboardCheck, Sparkles, MapPin } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";
import { WHY_POINTS } from "@/lib/data";

const ICONS = { ClipboardCheck, Sparkles, MapPin };

const WhyChoose = () => (
  <section id="perche" data-testid="why-section" className="bg-[#1A2E2A] py-28 lg:py-36 relative overflow-hidden">
    <div
      className="absolute -top-40 -right-40 w-[34rem] h-[34rem] rounded-full bg-[#489A88]/15 blur-3xl"
      aria-hidden="true"
    />
    <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
      <Reveal className="max-w-2xl mb-16">
        <p className="text-xs uppercase tracking-[0.3em] font-semibold text-[#7BC4B2]">04 — Perché Scegliere lo Studio</p>
        <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-white leading-[1.1]">
          Professionalità e <span className="italic text-[#7BC4B2]">Cura del Paziente</span>
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-3 gap-6">
        {WHY_POINTS.map((point, i) => {
          const Icon = ICONS[point.icon];
          return (
            <Reveal key={point.title} delay={i * 0.12}>
              <div
                data-testid={`why-card-${i}`}
                className="group h-full rounded-[1.75rem] bg-white/[0.05] border border-white/10 p-9 backdrop-blur-sm hover:bg-white/[0.09] hover:border-[#489A88]/40 transition-[background-color,border-color] duration-500"
              >
                <div className="w-14 h-14 rounded-2xl bg-[#489A88]/20 flex items-center justify-center mb-7 group-hover:bg-[#489A88]/30 transition-colors duration-500">
                  <Icon className="w-6 h-6 text-[#7BC4B2]" />
                </div>
                <h3 className="font-['Outfit'] text-xl font-medium text-white">{point.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-white/65">{point.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export default WhyChoose;
